import React from 'react'

function SideNavProfile() {
    return (
    <div id="side-nav" className="pl-5 pt-5 pb-3 container bg-primary border-bottom border-dark">
        <div className="pl-3 mx-auto">
            <div className="media">
                <img src="./Bhuvaneshwaran.jpg" className="rounded-lg shadow-lg" alt="Bhuvaneshwaran" width="70%"/>
            </div>
        </div>
        <h4 className="mt-3 text-light text-monospace font-weight-normal">Web Developer</h4>
    </div>
    )
}

export default SideNavProfile
